
//
// Load helpers into global namespace
//

require('./polyfills');
require('./helpers');


//
// Set up Sentry
//

var RavenClient;

function Sentry_dispatchCustomError (text) {
  if (Raven) RavenClient.captureMessage(text);
}

function Sentry_captureError (ex) {
  if (Raven) RavenClient.captureException(ex);
}

function Sentry_setOrg (org) {
  if (Raven) {
    log('Raven::setOrg -', org);
    RavenClient.setUserContext({
      hostname: HOSTNAME,
      org_name: org.name,
      org_id:   org.org_id
    });
  }
}

function Sentry_dispatchPoke () {
  if (Raven) RavenClient.captureMessage("POKE[JS]: Not a real error, just testing Sentry", [], { level: 'debug' });
}


//
// Init Widgets and Controllers
//

function initAll () {
  var Widgets     = require('./widgets');
  var Controllers = require('./controllers');

  Widgets.initAllWithin(document);
  Controllers.initAllWithin(document);
}


// Init Sentry and link init function

if (!isLocal() && typeof DSN_KEY !== 'undefined' && Raven) {
  var ravenOptions = {
    autoBreadcrumbs: { console: false } // Don't hijack console.log
  };
  RavenClient = Raven.config(DSN_KEY, ravenOptions).install();
  RavenClient.setEnvironment(ENVIRONMENT);
  Raven.context(initAll);
  if (typeof ORG !== 'undefined') Sentry_setOrg(ORG);
} else {
  initAll();
}

